// prettier-ignore
module.exports.winOffsetWidth = () => {
    const w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0];
    return w.innerWidth || e.clientWidth || g.clientWidth;
};

// prettier-ignore
module.exports.winOffsetHeight = () => {
    const w = window,
         d = document,
         e = d.documentElement,
         g = d.getElementsByTagName('body')[0];
    return w.innerHeight || e.clientHeight || g.clientHeight;
};

// prettier-ignore
module.exports.winWidth = () => {
    const d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0];
    return e.clientWidth || g.clientWidth;
};

// prettier-ignore
module.exports.winHeight = () => {
    const d = document,
         e = d.documentElement,
         g = d.getElementsByTagName('body')[0];
    return e.clientHeight || g.clientHeight;
};

// prettier-ignore
module.exports.docHeight = () => {
    const g = document.body,
          e = document.documentElement;
    return typeof document.height !== 'undefined' ? document.height : Math.max(g.scrollHeight, g.offsetHeight, e.clientHeight, e.scrollHeight, e.offsetHeight);
};

// prettier-ignore
module.exports.getWinScrollTop = () => {
    const w = window,
          d = document,
          g = d.getElementsByTagName('body')[0];
    return w.pageYOffset !== undefined ? w.pageYOffset : (d.documentElement || g.parentNode || g).scrollTop;
};
